import {
  PageLayoutService,
  ProductListComponent,
  ProductListComponentService,
  ViewConfig,
} from '@spartacus/storefront';
import { Component, ViewEncapsulation } from '@angular/core';
import { GlobalMessageService } from '@spartacus/core';
import { CategoryPageService } from 'src/app/customServices/category-page.service';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject, takeUntil } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ProductListService } from 'src/app/services/feature/product-list.service';
@Component({
  selector: 'app-category-page',
  templateUrl: './category-page.component.html',
  styleUrls: ['./category-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CategoryPageComponent extends ProductListComponent {
  isMobile: boolean;
  categoryCode: string;
  defaultPageSize: any = 12;
  searchQuery: any;
  categoryPageData$: Observable<any> = this.clpService.model$;
  baSeries: any;
  private readonly destroy$ = new Subject<void>();
  constructor(
    productListComponentService: ProductListComponentService,
    globalMessageService: GlobalMessageService,
    pageLayoutService: PageLayoutService,
    scrollConfig: ViewConfig,
    public clpService: CategoryPageService,
    private activatedRoute: ActivatedRoute,
    public breakpointObserver: BreakpointObserver,
    public productListService: ProductListService
  ) {
    super(pageLayoutService, productListComponentService, globalMessageService, scrollConfig);
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
      this.isMobile = result.matches;
      if (this.isMobile) {
        this.setViewMode(this.ViewModes.Grid);
      } else {
        this.setViewMode(this.ViewModes.List);
      }
    });
  }
  override ngOnInit(): void {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.baSeries = decodeURIComponent(data?.['param3']);
      this.categoryCode = data?.['categoryCode'];
      this.searchQuery = '';
    });
  }

  changePageSize(pageSize: any, model: any) {
    this.defaultPageSize = pageSize;
    this.searchProduct(model.pagination.currentPage, Number(pageSize), model.pagination.sort, model);
  }

  changePage(page: number, model: any) {
    this.searchProduct(page, model.pagination.pageSize, model.pagination.sort, model);
  }

  searchProduct(currentPage: any, pageSize: any, sort: string, model: any) {
    const pagination = {
      currentPage: currentPage,
      pageSize: pageSize,
      sort: sort,
    };
    const query = this.productListService.DecodeQuery(model.currentQuery?.query.value);
    this.changePageCustom(0, model);
  }

  changePageCustom(currentPage, model) {
    const query = this.productListService.DecodeQuery(model.currentQuery?.query.value);
    this.clpService
      .getCategoryPageData(this.categoryCode, query, currentPage, this.defaultPageSize, model.pagination.sort)
      .subscribe();
  }
  sortListClp(e, model) {
    const query = this.productListService.DecodeQuery(model.currentQuery?.query.value);
    this.clpService
      .getCategoryPageData(this.categoryCode, query, model.pagination.currentPage, this.defaultPageSize, e)
      .subscribe();
  }
  override ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
